import { IActivationCreate } from "@/models/IActivationCreate";

import { BaseRepository } from "@/repositories/BaseRepository";

class ActivationCreateRepository extends BaseRepository<IActivationCreate> {
    constructor() {
        super("/Activations");
    }
}

const activationcreateRepository = new ActivationCreateRepository();

export { ActivationCreateRepository, activationcreateRepository };
